//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { WebsiteRenderContextDisplayItem } from './WebsiteRenderContextDisplayItem';
import { WebsiteBlockType } from './Enums';

export abstract class WebsiteBlockDisplayItem extends ItemBase {
    ID: string | null = null;
    WebsitePageID: string | null = null;
    WebsiteID: string | null = null;
    SchoolID: string | null = null;
    OrderIndex: number = 0;
    RenderContext: WebsiteRenderContextDisplayItem | null = null;
    Url: string | null = null;
    ScriptTag: string | null = null;
    abstract readonly WebsiteBlockType: WebsiteBlockType;

    static readonly ClassName: string = "WebsiteBlockDisplayItem";
}
